import { Spinner } from '@oysterjs/ui/spinner';
import { TransitionDiv } from '@oysterjs/ui/async';

/**
 * Centered overlay loader shown above the list while an edit-page route's
 * loader is still in flight. Matches the loader used by the custom presets
 * edit page so the entire app's slideout-load transitions feel the same.
 */
export function LibraryEditOverlayLoader() {
  return (
    <div className="fixed z-50 top-0 left-0 w-full h-full flex items-center justify-center">
      <TransitionDiv className="my-16 flex items-center justify-center">
        <div className="rounded-lg bg-white dark:bg-neutral-800 p-10 shadow">
          <Spinner size="size-10" color="neutral" />
        </div>
      </TransitionDiv>
    </div>
  );
}
